<template>
  <div class="d-flex" style="width: 100%">
    <div 
      class="d-flex justify-center rounded-lg py-2 px-2 elevation-6"
      style="background-color: #45AEE9"
    >
      <v-icon color="white">mdi-purse</v-icon>
    </div>

    <div class="d-flex flex-column flex-grow-1 ml-3">
      <div class="d-flex">
        <div><strong>Credit</strong></div>
        <div class="ml-auto text-body-2 grey--text">
          {{ formatCurrency(item.amount_cents) }}
        </div>
      </div>

      <div class="d-flex text-body-2 grey--text">
        <div class="limit-195">{{ item.description }}</div>
        <div class="ml-auto">
          {{ formatDate(item.history_time) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatters from '@/lib/formatters'

export default {
  name: 'PaymentHistoryItem',

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
  }),

  methods: {
    ...formatters,
  },
}
</script>

<style scoped>
  .limit-195 {
    max-width: 195px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>